import React from 'react';
import store from '../../../Store';
import withRouter from "react-router/withRouter";
import getOrganization from "../../../ajax/actions/organization/organization_get";
import {connect} from "react-redux";
import getActivityLogs from "../../../ajax/actions/activity-log/activity_logs_get";
import {setOrganizationDashboardData, setOrganizationId} from "../../organization/OrganizationDashboard-Action";
import getSites from "../../../ajax/actions/sites/sites_get";
import getActivityEvents from "../../../ajax/actions/activity-log/activity_events_name_get";
import {onActivityLogSiteReset,onActivityLogEventReset} from "./ActivityList-Actions";

class ActivityWorker extends React.Component {
    componentDidMount() {
        let id = this.props.match.params.org_id
        store.dispatch(setOrganizationId(id));
        store.dispatch(getActivityLogs(id));
        store.dispatch(getOrganization(id))
        store.dispatch(getSites(id))
        store.dispatch(getActivityEvents())
        store.dispatch(onActivityLogSiteReset());
        store.dispatch(onActivityLogEventReset());

    }

    componentDidUpdate(prevProps) {
        if (this.props.getOrganization !== prevProps.getOrganization) {
            let {success} = this.props.getOrganization;
            if (success) {
                store.dispatch(setOrganizationDashboardData());
            }
        }
    }

    render() {
        return null
    }
}

function mapStateToProps(state) {
    let {getOrganization} = state;

    return {getOrganization};
}

export default withRouter(connect(mapStateToProps)(ActivityWorker));